import { EvaChartStates } from "types/factory";

import { createMpcCompatibleTooltipOptions } from "./mpcTooltip";

export function translateRateTimeResponseTooltipOptions(states: EvaChartStates) {
  return createMpcCompatibleTooltipOptions(states, {
    className: "chart-tooltip-container"
  });
}
